import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

interface TokenPayload {
  uid?: string
  exp?: number
}

function decodeToken(token: string): TokenPayload | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 2) return null

    const payload = parts[0]
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const decoded = atob(padded)
    return JSON.parse(decoded)
  } catch {
    return null
  }
}

export default function BillingLinkPage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    if (!token) {
      setError('トークンが指定されていません。')
      return
    }

    const payload = decodeToken(token)
    if (!payload) {
      setError('無効なトークンです。')
      return
    }

    // Check expiration
    const now = Math.floor(Date.now() / 1000)
    if (typeof payload.exp === 'number' && payload.exp < now) {
      setError('トークンの有効期限が切れています。LINEから再度アクセスしてください。')
      return
    }

    // Store user ID and redirect
    const uid = payload.uid
    if (uid) {
      try {
        sessionStorage.setItem('user_id', uid)
      } catch {
        // Ignore
      }
    }

    // Redirect to billing page
    navigate('/?billing=true', { replace: true })
  }, [token, navigate])

  if (error) {
    return (
      <main className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-gray-700 px-6">
        <div className="max-w-md w-full text-center space-y-4">
          <div className="text-lg font-medium text-red-600">{error}</div>
          <button
            type="button"
            className="mt-2 inline-flex items-center justify-center rounded-md bg-green-500 px-4 py-2 text-white shadow-sm hover:bg-green-600"
            onClick={() => navigate('/', { replace: true })}
          >
            トップへ戻る
          </button>
        </div>
      </main>
    )
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-gray-700 px-6">
      <div className="max-w-md w-full text-center">
        <div className="text-lg font-medium">読み込み中…</div>
      </div>
    </main>
  )
}
